import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { FlightHoursDetails } from '../models/FlightHoursDetails';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';


@Injectable()
export class FlightHoursService {

  myHeader: Headers;
  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('flight hour Service Initialized...');
  }
  // Submit / Edit Hours
  getSubmitHoursDetails(contractNumber: string) {
    return this.authHttp.get(`/api/FlightHours/SubmitHours/${contractNumber}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getSubmitHoursDetails has failed ' + res.status);
      } else {
        console.log(res.json());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getCo2CalcInfo(ACnum: string) {
    return this.authHttp.get(`/api/FlightHours/GetCo2calcInfo/${ACnum}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GetCo2calcInfo has failed ' + res.status);
      } else {
        console.log(res.json());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getCDDMakeList(AcType: string) {
    return this.authHttp.get(`/api/FlightHours/GetCDDACMakeList/${AcType}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GetCDDACMakeList has failed ' + res.status);
      } else {
        console.log(res.json());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getCDDModelList(AcType: string, AcMfgNum: string) {
    return this.authHttp.get(`/api/FlightHours/GetCDDACModelList?AcType=${AcType}&AcMfgNum=${AcMfgNum}`,
    { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GetCDDACModelList has failed ' + res.status);
      } else {
        console.log(res.json());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getUpdatedFlightHoursDetails(contractNumber: string) {
    return this.authHttp.get(`/api/FlightHours/EditHours/${contractNumber}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getUpdatedFlightHoursDetails has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getInvoiceByTransID(transactionID: string) {
    return this.authHttp.get(`/api/FlightHours/GetInvoiceByTransID?TransactionID=${transactionID}`,
    { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getInvoiceByTransID has failed ' + res.status);
      } else {
        console.log('getinvocie', res);

        return res;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }


  getValidateSubmitFlightHoursDetails(flightHourDetail: FlightHoursDetails) {
    return this.authHttp.post(`/api/FlightHours/ValidateSubmitFlightHoursDetails`, flightHourDetail, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getValidateSubmitFlightHoursDetails has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }
  SaveMTSAuthForminfo(MTSAuthFormInfo: any) {
    return this.authHttp.post(`/api/FlightHours/SubmitMTSAuthFormInfo`, MTSAuthFormInfo, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('SubmitMTSAuthFormInfo has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  SaveAndSendMTSAuthFormInfo(MTSAuthFormInfo: any, loMTSAuthFormInfoPDFVersion: any){

    const postRequest1$ =  this.authHttp.post(`/api/FlightHours/SendMTSAuthForminfo`,loMTSAuthFormInfoPDFVersion,{ headers: this.myHeader });
    const postRequest2$ = this.authHttp.post(`/api/FlightHours/SubmitMTSAuthFormInfo`, MTSAuthFormInfo, { headers: this.myHeader });

    // Use forkJoin to make both POST requests concurrently
    forkJoin([postRequest1$, postRequest2$]).subscribe(
      ([response1, response2]) => {
        console.log('Response from sendMTS API:', response1);
        console.log('Response from SaveMTS API:', response2);
        // Handle responses here after both requests complete
      },
      (error) => {
        console.error('An error occurred:', error);
      }
    );
  }


  SendMTSAuthForminfo( loMTSAuthFormInfoPDFVersion: any) {
    console.log('inside sendmethod',loMTSAuthFormInfoPDFVersion);
    return this.authHttp.post(`/api/FlightHours/SendMTSAuthForminfo`,loMTSAuthFormInfoPDFVersion, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('SendMTSAuthForminfo has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }


  CreateInvoiceSubmitHours(flightHourDetail: FlightHoursDetails) {
    return this.authHttp.post(`/api/FlightHours/CreateInvoiceSubmitHours`, flightHourDetail, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('CreateInvoiceSubmitHours has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  CreateInvoiceEditHours(flightHourDetail: FlightHoursDetails) {
    return this.authHttp.post(`/api/FlightHours/CreateInvoiceEditHours`, flightHourDetail)
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('CreateInvoiceEditHours has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  calculateTotals(contractNumber: string) {
    return this.authHttp.get(`/api/FlightHours/CalculateTotals`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  createInvoice(contractNumber: string) {
    return this.authHttp.get(`/api/FlightHours/CalculateTotals`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  // View Hours
  ViewHours(contractNumber: string, serial: any, equipId: number) {

    if (!contractNumber) {
      console.log('contractNumber is empty while calling ViewHours()');
      throw new Error('contractNumber is empty while calling ViewHours()');
    } else {
      // contractNumber = contractNumber.replace(/%20/gi, '');
      return this.authHttp.get(`/api/FlightHours/ViewHours?psContractNumber=${contractNumber}
    &piEquipmentId=${equipId}&psSerialNmbr=${serial}`).map(res => {
          if (res.status < 200 || res.status > 300) {
            throw new Error('login request has failed ' + res.status);
          } else {
            return res.json();
          }
        }).catch(err => {

          if (err.status === 401 || err.message === 'No JWT present or has expired') {
            this.auth.logOut();
          }

          return Observable.throw(err);
        });
    }

    // ???
    // contractNumber = contractNumber.replace(/%20/gi, '');
    // return this.authHttp.get(`/api/FlightHours/ViewHours?psContractNumber=${contractNumber.replace(/%20/gi, '')}
    // &piEquipmentId=${equipId}&psSerialNmbr=${serial}`).map(res => {
    //   if (res.status < 200 || res.status > 300) {
    //     throw new Error('login request has failed ' + res.status);
    //   } else {
    //     return res.json();
    //   }
    // });
  }

  getViewHoursGraphData(contractNumber: string, equipId: any, type: string, serial: string) {
    return this.authHttp
      .get(`/api/FlightHours/ViewHoursGraphData?psContractNumber=${contractNumber}
      &piEquipId=${equipId}&psType=${type}&psSerial=${serial}`, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getViewHoursGraphData ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  getFlightHoursAssets(contractNumber: string) {
    return this.authHttp.get(`/api/FlightHours/GetFlightHoursAssets/${contractNumber}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getFlightHoursMinimumsGraph(contractNumber: string, reportingDate: string) {
    return this.authHttp.get(`/api/FlightHours/GetFlightHoursMinimumsGraph?ContractNumber=${contractNumber}&reportingDate=${reportingDate}`, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('login request has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }

  getGetFRFHCreditsInfo(poFlightHoursDetails: FlightHoursDetails) {
    return this.authHttp.post(`/api/FlightHours/GetFRFHCreditsInfo`, poFlightHoursDetails, { headers: this.myHeader })
      .map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('getGetFRFHCreditsInfo has failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/flight-hours.service.ts